export enum UserProfilePagePermissions {
  manageCompanies = 'manageCompanies',
}
